module.exports = __webpack_public_path__ + "media/bootstrap-icons/layout-sidebar-inset-c364f714.svg";